module.exports = __webpack_public_path__ + "static/design-cotton.777d5ac9.svg";